import * as React from "react";
import { gql, useMutation, ApolloError } from "@apollo/client";
import {
  DeleteIndustryMutationMutation,
  DeleteIndustryMutationMutationVariables,
} from "../../../../schemaTypes";
import { normalizeErrors } from "../../../../utils/normalizeErrors";
import { NormalizedErrorMap } from "../../../../types/NormalizedErrorMap";

export const deleteIndustryMutation = gql`
  mutation DeleteIndustryMutation($id: String!) {
    deleteIndustry(id: $id) {
      errors {
        path
        message
      }
      message
    }
  }
`;

interface Props {
  onMessage?: (message: string) => void;
  children: (
    data: {
      submit: (
        values: DeleteIndustryMutationMutationVariables
      ) => Promise<{
        errors: NormalizedErrorMap | null;
        message?: string;
      }>;
      loading: boolean;
      error?: ApolloError;
    }
  ) => React.ReactElement | null;
}

export const DeleteIndustry: React.FC<Props> = ({ children, onMessage }) => {
  const [_deleteIndustryMutation, { loading, error }] = useMutation<
    DeleteIndustryMutationMutation,
    DeleteIndustryMutationMutationVariables
  >(deleteIndustryMutation);

  const submit = async (
    values: DeleteIndustryMutationMutationVariables
  ) => {
    const { data } = await _deleteIndustryMutation({
      variables: values,
    });

    const errors = data?.deleteIndustry?.errors
      ? normalizeErrors(data.deleteIndustry.errors)
      : null;

    if (data?.deleteIndustry?.message && onMessage) {
      onMessage(data.deleteIndustry.message);
    }

    return {
      errors,
      message: data?.deleteIndustry?.message ?? undefined,
    };
  };

  return children({ submit, loading, error });
};
